import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CreditCardForm } from '@/common/components/CreditCardForm/CreditCardForm';
import { TCreditCardFormSchema } from '@/common/components/CreditCardForm/CreditCardForm.schema';
import { useCreditCardForm } from '@/common/components/CreditCardForm/CreditCardForm.utils';
import { useSetupPaymentMethod } from '@/common/contexts/stripe/StripeProvider';
import { FlowLayout } from '@/common/layouts/FlowLayout/FlowLayout';
import { useFlowLayout } from '@/common/layouts/FlowLayout/FlowLayout.context';
import { notify } from '@/common/utils/toast/toast';

export function AutomaticPaymentMethodStep() {
  const { t } = useTranslation();
  const { goNext } = useFlowLayout();
  const { setupPaymentMethod } = useSetupPaymentMethod();
  const methods = useCreditCardForm();

  const onSubmit = async (data: TCreditCardFormSchema) => {
    try {
      await setupPaymentMethod(data);
      goNext();
    } catch (err) {
      notify({
        type: 'error',
        message: t('dashboard.credits.add_card.error'),
      });
    }
  };

  return (
    <FlowLayout.Content
      primaryAction={{
        children: t(
          'dashboard.automatic_payment.setup.step.payment_method.primary_action'
        ),
        onPress: methods.handleSubmit(onSubmit),
        loading: methods.formState.isSubmitting,
      }}
    >
      <FormProvider {...methods}>
        <CreditCardForm />
      </FormProvider>
    </FlowLayout.Content>
  );
}
